import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Navbar } from './components/landing/Navbar';
import { Hero } from './components/landing/Hero';
import { Problem } from './components/landing/Problem';
import { Solution } from './components/landing/Solution';
import { AliceApp } from './components/landing/AliceApp';
import { Courses } from './components/landing/Courses';
import { WhoIsThisFor } from './components/landing/WhoIsThisFor';
import { Benefits } from './components/landing/Benefits';
import { Testimonials } from './components/landing/Testimonials';
import { PricingCTA } from './components/landing/PricingCTA';
import { FAQ } from './components/landing/FAQ';
import { FinalCTA } from './components/landing/FinalCTA';
import { Footer } from './components/landing/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-heading selection:bg-link-blue selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Problem data-id="element-5" />
        <Solution data-id="element-6" />
        <AliceApp data-id="element-7" />
        <Courses data-id="element-8" />
        <WhoIsThisFor data-id="element-9" />
        <Benefits data-id="element-10" />
        <Testimonials data-id="element-11" />
        <PricingCTA data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}